import { useMemo } from 'react'
import { AccessLevelSetting as Input } from 'ui-components'
import { useAuth } from 'user-auth'
import { updateMapAccess } from '~map-preview/api/updateMapAccess'
import { useGetMapById } from '~map-preview/queries/useGetMapById'
import { useMap } from '~map-preview/states/map'

function AccessLevelSetting() {
  const { user } = useAuth()
  const map = useMap()
  const { refetch } = useGetMapById(map.id)

  const isWorkspaceMember = useMemo(() => {
    if (!map || !Object.keys(map).length) return false
    if (!user) return false

    return map.workspace.memberCollection.items.some(
      (member) => member.user.id === user.id
    )
  }, [map, user])

  const handleChange = async (_, value) => {
    if (value !== map.isPublic) {
      await updateMapAccess({ id: map.id, isPublic: value })
      await refetch()
    }
  }

  return (
    <Input
      canUpdateAccess={isWorkspaceMember}
      value={map.isPublic}
      onChange={handleChange}
    />
  )
}

export { AccessLevelSetting }
